import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OutingObservableService implements OnDestroy {
  
  private submissionSubject = new BehaviorSubject<any | null>(this.getFromLocalStorage());
  submission$ = this.submissionSubject.asObservable();

  constructor() {
    // Listen for changes in other tabs/windows
    window.addEventListener('storage', this.handleStorageChange);
  }

  setSubmissionData(data: any) {
    this.submissionSubject.next(data);
    this.saveToLocalStorage(data);
  }

  private saveToLocalStorage(data: any) {
    if (data) {
      localStorage.setItem('submissionData', JSON.stringify(data));
    } else {
      localStorage.removeItem('submissionData');
    }
  }

  private getFromLocalStorage(): any | null {
    const stored = localStorage.getItem('submissionData');
    return stored ? JSON.parse(stored) : null;
  }

  private handleStorageChange = (event: StorageEvent) => {
    if (event.key === 'submissionData') {
      const newValue = event.newValue ? JSON.parse(event.newValue) : null;
      this.submissionSubject.next(newValue);
    }
  };

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.handleStorageChange);
  }
}
